import React, { memo } from 'react';
import { Button } from 'appkit-react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import action from '@flux/action';

function NoDataContent(props) {
  const history = useHistory();

  const {
    userInfo: { given_name = 'User' },
    saveCreateProjectData,
    clearCompanyName,
  } = props;

  const handleCreateProject = () => {
    saveCreateProjectData({ init: true });
    clearCompanyName();
    history.push('/projects/create');
  };

  return (
    <div className="no-listdata-content">
      <p className="content">
        Hello {given_name}, welcome to M&A Gateway <br />
        <span className="role-control">Create your first project</span>
      </p>
      <div className="btn-wrapper role-control">
        <Button size="xl" className="create-btn" onClick={handleCreateProject}>
          <span className="appkiticon icon-circle-plus-fill" />
          Create project
        </Button>
      </div>
    </div>
  );
}

NoDataContent.defaultProps = {
  userInfo: {},
};
NoDataContent.propTypes = {
  userInfo: PropTypes.object,
};

const mapStateToProps = ({ login }) => ({
  userInfo: login.userInfo,
});
const mapDispatchToProps = (dispatch) => ({
  saveCreateProjectData(data) {
    dispatch(action.saveData(data));
  },
  clearCompanyName() {
    dispatch(action.clearCompanyName());
  },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(memo(NoDataContent));
